import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from 'common/components/Icon';

import './Title.scss';

const Title = ({ children, className, showIcon }) => (
    <h5 className={classNames('title', className)}>
        {showIcon && <Icon icon="arrow-right" />}
        {children}
    </h5>
);

Title.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    showIcon: PropTypes.bool,
};

Title.defaultProps = {
    className: null,
    showIcon: true,
};

export default Title;
